import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditChallenge = () => {
  const [formData, setFormData] = useState({});
  const [schools, setSchools] = useState([]);
  const [classOption, setClassOption] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [ldcOptions, setLdcOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);

  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const breadcrumb = {
    current_section: "Challenge",
    sections: [
      { name: "Challenge", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  const challengeId = window.location.pathname.split("/").pop();

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getTeacherSchools?userId=${localStorage.getItem("userId")}`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchools(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchLDCs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/ldc/ldcget`,
          fetchOptions
        );
        const result = await response.json();
        setLdcOptions(
          convertIntoSelect2Options(result.return.ldc, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchEvents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllEvents`,
          fetchOptions
        );
        const result = await response.json();
        setEventOptions(convertIntoSelect2Options(result, "id", "nomeevento"));
      } catch (error) {
        console.error(error);
      }
    };

    const fetchChallengeData = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getChallenge?challengeId=${challengeId}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error("Error fetching challenge data:", result.error);
          return;
        }

        if (result.datafine == null) result.oneDay = true;

        setFormData(result);
      } catch (error) {
        console.error(error);
      }
    };

    fetchChallengeData();
    fetchSchools();
    fetchLDCs();
    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola/classi?idscuola=${selectedSchool}&annoscolastico=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        setClassOption(
          customConvertIntoSelect2OptionsClasses(
            result.return.classi,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchClasses();
  }, [selectedSchool]);

  useEffect(() => {
    if (formData.luogoid == null && formData.luogoid == undefined) {
      return;
    }

    const fetchEvents = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllEvents?ldcId=${formData.luogoid}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          console.error("Error fetching events:", result.error);
          setEventOptions([]);
          return;
        }
        setEventOptions(convertIntoSelect2Options(result, "id", "nomeevento"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchEvents();
  }, [formData.luogoid]);

  useEffect(() => {
    setSelectedSchool(formData.idscuola || null);
    setSelectedClass(formData.Classes?.[0].idclassi || null);
  }, [formData.idscuola]);

  useEffect(() => {
    if (formData.oneDay)
      setFormData((prev) => ({ ...prev, datafine: null, orafine: null }));
  }, [formData.oneDay]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    const fetchOptions = getFetchOptions(
      "application/json",
      { challengeId: challengeId, challengeData: formData },
      "PUT"
    );

    fetch(`${axios.defaults.baseBFFUrl}/fe/updateChallenge`, fetchOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.error) {
          console.error("Error saving challenge:", result.error);
          alert("Errore durante il salvataggio della challenge.");
        } else {
          alert("Challenge salvata con successo!");
          window.location.href = "/challenges";
        }
      });
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/challenges">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista challenge
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* Class Management */}
      <div className="card custom-card">
        <div className="card-header">Gestione Classi</div>
        <div className="card-body">
          <p>
            <strong>Quali classi partecipano a questa challenge?</strong> Scegli
            la scuola di appartenenza e le classi interesste.
          </p>
          <div className="row row-cols-1 row-cols-lg-2">
            <div className="col">
              <label htmlFor="school">
                Scuola <b>*</b>
              </label>
              <Select
                options={schools}
                id="school"
                name="school"
                value={schools?.filter(function (option) {
                  return option.value === selectedSchool;
                })}
                onChange={(e) => {
                  setSelectedSchool(e?.value);
                  setFormData({
                    ...formData,
                    idscuola: e?.value,
                    status: "Planned",
                  });
                }}
                classNames={"form-control"}
                placeholder="Scegli scuola..."
                isSearchable
                isClearable
                isDisabled={formData.idscuola ? true : false}
              />
            </div>
            <div className="col">
              <label htmlFor="classe">
                Classe <b>*</b>
              </label>
              <Select
                options={classOption}
                id="classe"
                name="classe"
                value={classOption?.filter(function (option) {
                  return option.value === selectedClass;
                })}
                onChange={(e) => {
                  setSelectedClass(e?.value);
                  setFormData({
                    ...formData,
                    classes: [e?.value],
                  });
                }}
                classNames={"form-control"}
                placeholder="Scegli classe..."
                isSearchable
                isClearable
                isDisabled={formData.Classes ? true : false}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Challenge Activities */}
      <div className="card custom-card">
        <div className="card-header">Attività della challenge</div>
        <div className="card-body">
          <div className="row rows-col-1 row-cols-lg-3 py-3">
            <div className="col" key={1}>
              <div className="form-group">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="attivitaselfie">
                    <input
                      type="checkbox"
                      id="attivitaselfie"
                      name="attivitaselfie"
                      checked={formData.attivitaselfie || false}
                      className="form-check-input"
                      onChange={(e) =>
                        handleInputChange(
                          `attivitaselfie`,
                          e.target.checked ? 1 : 0
                        )
                      }
                    />
                    &nbsp;Selfie (100 punti)
                  </label>
                </div>
              </div>
              <input
                id="attivitaselfie_mult"
                name="attivitaselfie_mult"
                placeholder="Moltiplicatore"
                className="form-control"
                disabled={!formData.attivitaselfie}
                onChange={(e) =>
                  handleInputChange("selfiemult", e.target.value)
                }
                value={formData.selfiemult || 1}
              />
            </div>
            <div className="col" key={2}>
              <div className="form-group">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="attivitachat">
                    <input
                      type="checkbox"
                      id="attivitachat"
                      name="attivitachat"
                      checked={formData.attivitachat || false}
                      className="form-check-input"
                      onChange={(e) =>
                        handleInputChange(
                          "attivitachat",
                          e.target.checked ? 1 : 0
                        )
                      }
                    />
                    &nbsp;Chat
                  </label>
                </div>
              </div>
              <input
                id="attivitachat_mult"
                name="attivitachat_mult"
                placeholder="Moltiplicatore"
                className="form-control"
                disabled={!formData.attivitachat}
                onChange={(e) => handleInputChange("chatmult", e.target.value)}
                value={formData.chatmult || 1}
              />
            </div>
            <div className="col" key={3}>
              <div className="form-group">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="attivitaricerca">
                    <input
                      type="checkbox"
                      id="attivitaricerca"
                      name="attivitaricerca"
                      checked={formData.attivitaricerca || false}
                      className="form-check-input"
                      onChange={(e) =>
                        handleInputChange(
                          "attivitaricerca",
                          e.target.checked ? 1 : 0
                        )
                      }
                    />
                    &nbsp;Ricerca (100 punti)
                  </label>
                </div>
              </div>
              <input
                id="attivitafoto_mult"
                name="attivitafoto_mult"
                placeholder="Moltiplicatore"
                className="form-control"
                disabled={!formData.attivitaricerca}
                onChange={(e) =>
                  handleInputChange("searchmult", e.target.value)
                }
                value={formData.searchmult || 1}
              />
            </div>
          </div>
        </div>
      </div>

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header">Dati generali</div>
        <div className="card-body">
          <div className="row row-cols-1">
            <div className="col">
              <label htmlFor="titolo">
                Titolo <b>*</b>
              </label>
              <input
                type="text"
                id="titolo"
                name="titolo"
                className="form-control"
                value={formData.titolo || ""}
                onChange={(e) => handleInputChange("titolo", e.target.value)}
              />
            </div>
            <div className="col mt-3">
              <label htmlFor="oneDay">
                <input
                  type="checkbox"
                  id="oneDay"
                  checked={formData.oneDay || false}
                  onChange={() => handleInputChange("oneDay", !formData.oneDay)}
                />
                &nbsp;Un solo giorno
              </label>
            </div>
          </div>
          <div className="row row-cols-4">
            <div className="col">
              <label htmlFor="datainizio">
                Dal <b>*</b>
              </label>
              <input
                type="date"
                id="datainizio"
                name="datainizio"
                className="form-control"
                value={formData.datainizio || ""}
                onChange={(e) =>
                  handleInputChange("datainizio", e.target.value)
                }
              />
            </div>
            <div className="col">
              <label htmlFor="orainizio">
                Ora inizio <b>*</b>
              </label>
              <input
                type="time"
                id="orainizio"
                name="orainizio"
                className="form-control"
                value={formData.orainizio || ""}
                onChange={(e) => handleInputChange("orainizio", e.target.value)}
              />
            </div>
            <div className="col">
              <label htmlFor="datafine">Al</label>
              <input
                type="date"
                id="datafine"
                name="datafine"
                className="form-control"
                value={formData.datafine || ""}
                onChange={(e) => handleInputChange("datafine", e.target.value)}
                disabled={formData.oneDay}
              />
            </div>
            <div className="col">
              <label htmlFor="orafine">Ora fine</label>
              <input
                type="time"
                id="orafine"
                name="orafine"
                className="form-control"
                value={formData.orafine || ""}
                onChange={(e) => handleInputChange("orafine", e.target.value)}
                disabled={formData.oneDay}
              />
            </div>
          </div>
          <div className="row">
            <div className="col mt-3">
              <label htmlFor="descrizione">
                Descrizione <b>*</b>{" "}
                <span className="text-danger">
                  {" "}
                  (La descrizione viene utilizzata per le attivita` di ricerca,
                  inserire quanti piu` dettagli possibili)
                </span>
              </label>
              <textarea
                id="descrizione"
                name="descrizione"
                className="form-control"
                rows="2"
                maxLength="1000"
                value={formData.descrizione || ""}
                onChange={(e) =>
                  handleInputChange("descrizione", e.target.value)
                }
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      {/* Cultural Places and Events */}
      <div className="card custom-card">
        <div className="card-header">Luoghi della cultura ed eventi</div>
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <label htmlFor="idLdc">
                Luogo della cultura <b>*</b>
              </label>
              <Select
                options={ldcOptions}
                id="idLdc"
                name="idLdc"
                value={ldcOptions?.filter(function (option) {
                  return option.value === Number(formData.luogoid);
                })}
                onChange={(e) => handleInputChange("luogoid", e?.value)}
                classNames={"form-control"}
                placeholder="Scegli luogo..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col-12 mt-2">
              <label htmlFor="idEvento">Eventi</label>
              <Select
                options={eventOptions}
                id="idEvento"
                name="idEvento"
                value={eventOptions?.filter(function (option) {
                  return option.value == Number(formData.events?.[0]);
                })}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    events: [Number(e?.value)],
                  }));
                }}
                classNames={"form-control"}
                placeholder="Scegli evento..."
                isSearchable
                isClearable
              />
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="saveButtonContainer">
        <button
          id="savePlaceBtn"
          name="savePlaceBtn"
          className="btn btn-success saveButton"
          type="button"
          onClick={handleSave}
        >
          &nbsp;Salva
        </button>
      </div>
    </div>
  );
};

export default EditChallenge;
